import styled from "styled-components";

export const BoxArea = styled.div`
    width: 140px;
    height: 36px;
    background-color: #FFF;
    border: 1px solid rgba(186,193,207, 0);
    border-radius: 18px;
    font-size: 13px;
    color: rgb(59, 56, 72);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const Subtract = styled.div`
    width: 36px;
    height: 36px;
    border: 1px solid rgba(255, 82, 82, 0.5);
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    cursor: pointer;

    svg {
        transition: all 0.2s ease;
        color: rgb(255, 82, 82);
        cursor: pointer;
        pointer-events: none;
    }

    &:hover{
        background-color: rgb(255, 82, 82);

        svg {
            color: #FFFFFF;
            transform: scale(1.2);
        }
    }
    &:active{
        background-color: rgb(214, 52, 52);

        svg {
            color: #FFFFFF;
            transform: scale(0.8);
        }
    }
`;

export const Value = styled.div`
    width: 68px;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: rgb(59, 56, 72);
    font-size: 16px;
    font-weight: 600;

    border-top: 1px solid rgba(186,193,207, 1);
    border-bottom: 1px solid rgba(186,193,207, 1);

    label {
        margin: 0px;
    }
`;

export const Add = styled.div`
    width: 36px;
    height: 36px;
    border: 1px solid rgba(47,187,105, 0.5);
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    cursor: pointer;

    svg {
        transition: all 0.2s ease;
        color: rgb(47,187,105);
        cursor: pointer;
        pointer-events: none;
    }

    &:hover{
        background-color: rgb(47,187,105);

        svg {
            color: #FFFFFF;
            transform: scale(1.2);
        }
    }
    &:active{
        background-color: rgb(36,150,84);

        svg {
            color: #FFFFFF;
            transform: scale(0.8);
        }
    }
`;